import QueryString from "qs";
import mainAxios from "../api/mainAxios";

export const getAllDiscussions = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_DISCUSSIONS_LOADING" });

    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const query = QueryString.stringify({
      populate: {
        messages: {
          fields: ["*"],
        },
      },
      sort: ["id:desc"],
      pagination: {
        pageSize: 10000,
      },
    });

    const response = await mainAxios.get(`api/discussions?${query}`, config);

    dispatch({ type: "GET_DISCUSSIONS_SUCCESS", payload: response.data });
  } catch (error) {
    console.error("error", error);
    dispatch({ type: "GET_DISCUSSIONS_FAILURE", payload: error.message });
  }
};
